// extracted by mini-css-extract-plugin
export default {"player":"listen_player__Q6A2+","audiocontrol":"listen_audiocontrol__WvZEt"};